import { AbstractState } from '@sancare/typescript-commons/src/store/types'
import type { Finess } from '@sancare/typescript-commons/src/types/finess'

import { PmsiTypeEnum } from '@/store/modules/settings/types'

export enum ConnectorType {
  CORA = 'cora',
  MEDSTAT = 'medstat',
  WEBPIMS = 'webpims',
  CAPITOOLS = 'capitools',
  EVENEMENTS_PMSI = 'evenements_pmsi',
  OPTISIM = 'optisim',
  SERVEUR_ETAT_PATIENT = 'serveur_etat_patient',
}

export const connectorsTypesLabels = {
  [ConnectorType.CORA]: 'Cora',
  [ConnectorType.MEDSTAT]: 'Medstat',
  [ConnectorType.WEBPIMS]: 'Webpims',
  [ConnectorType.CAPITOOLS]: 'Capitools',
  [ConnectorType.EVENEMENTS_PMSI]: 'Evènements PMSI',
  [ConnectorType.OPTISIM]: 'Optisim',
  [ConnectorType.SERVEUR_ETAT_PATIENT]: 'Serveur état patient',
}

export const fileConnectors = [
  ConnectorType.CORA,
  ConnectorType.CAPITOOLS,
  ConnectorType.EVENEMENTS_PMSI,
  ConnectorType.OPTISIM,
  ConnectorType.SERVEUR_ETAT_PATIENT,
]

export const httpConnectors = [
  ConnectorType.MEDSTAT,
  ConnectorType.WEBPIMS,
]

export enum ConnectorFlowType {
  AUTO = 'auto_validation',
  MANUAL = 'manual_validation',
  REVALUABLE = 'revaluable_state_update',
  DOCUMENT_TYPES_PRESENCE_UPDATE = 'document_types_presence_update',
  SUGGESTIONS_UPDATE = 'suggestions_update',
}

export const connectorFlowVersions = {
  [ConnectorType.CORA]: ['2.2', '2.4'],
  [ConnectorType.WEBPIMS]: ['2.1', '3.0'],
  [ConnectorType.MEDSTAT]: ['1.1'],
  [ConnectorType.CAPITOOLS]: ['2.4'],
  [ConnectorType.EVENEMENTS_PMSI]: ['2.2', '2.4'],
  [ConnectorType.OPTISIM]: ['2.4'],
  [ConnectorType.SERVEUR_ETAT_PATIENT]: ['2.4'],
}

export const defaultExternalName = {
  [ConnectorType.CORA]: 'cora',
  [ConnectorType.CAPITOOLS]: 'capitools',
  [ConnectorType.EVENEMENTS_PMSI]: '',
  [ConnectorType.OPTISIM]: 'optisim',
  [ConnectorType.SERVEUR_ETAT_PATIENT]: '',
}

export const connectorsConnexionInputs = {
  externalName: [ConnectorType.CAPITOOLS, ConnectorType.CORA, ConnectorType.EVENEMENTS_PMSI, ConnectorType.OPTISIM, ConnectorType.SERVEUR_ETAT_PATIENT],
  host: httpConnectors,
  isSecureSsl: httpConnectors,
  apiKey: [ConnectorType.MEDSTAT, ConnectorType.WEBPIMS],
  username: [ConnectorType.WEBPIMS],
  password: [ConnectorType.WEBPIMS],
  pmsiType: [ConnectorType.CORA],
}

export type ConnectorConfig = {
  id: number
  connectorType: ConnectorType | null
  externalName: string | null
  host: string
  apiKey: string
  apiKeyPart: string
  username: string
  password: string
  isAllFiness: boolean
  isSecureSsl: boolean
  legalFinessList: Finess[]
  geoFinessList: Finess[]
  flows: ConnectorFlow[]
}

export const emptyConnector: ConnectorConfig = {
  id: null,
  connectorType: null,
  host: '',
  apiKey: null,
  apiKeyPart: null,
  username: null,
  password: null,
  isSecureSsl: false,
  isAllFiness: true,
  externalName: '',
  legalFinessList: [],
  geoFinessList: [],
  flows: [],
}

export type ConnectorFlow = {
  id: number
  type: ConnectorFlowType
  path: string
  formatVersion: string
  pmsiType: PmsiTypeEnum
}

export class ConnectorConfigState extends AbstractState {
  connectorsConfigList: ConnectorConfig[]
}
